<template>
  <div class="Questionnaire">
    <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <form v-if="quiz">
            <div class="progress">
              <div id="dynamic" class="progress-bar progress-bar-success active" style="width: 0%" role="progressbar">
                <span id="current-progress"></span>
              </div>
            </div>
            <span class="progress-bar-data" :key="currentProgress">{{currentProgress}}%</span>
            <div @click="goToNextQuiz" class="skip next"><a href="javascript:void(0)">Skip Question</a></div>
            <div @click="goToNextQuiz" class="skip mobile"><a href="javascript:void(0)">Skip<i class="fa fa-angle-right"></i></a></div>
            <transition name="fade" mode="out-in">
              <div class="question-box" :key="quiz.question" v-if="quiz">
                <h4 class="question">{{quiz.question}}</h4>
                <ul class="answers">
                  <li v-for="(option,index) in quiz.options" :key="index"
                      :class="{'selected': index===selectedOptionIndex,
                        'right' : index===selectedOptionIndex && correctAnswer && isStatus,
                        'wrong' : index===selectedOptionIndex && !correctAnswer && isStatus,
                        'disabled': isDisabled,
                        }"
                      @click="checkAnswer(index)">
                    <input type="radio" name="q1">
                    <label>{{option.option}}</label>
                  </li>
                </ul>
              </div>
            </transition>
          </form>
        </div>
      </div>
    </div>
  
      <div class="quiz-answer quiz-timer" v-show="showTimer">
      <transition name="fade" mode="out-in">
        <div class="quiz-answer-inner" :key="quiz.question" >
          <div class="timer-box">
            <div class="progress-blue">
              <span class="progress-left">
                <span id="leftBar" class="progress-bar"></span>
              </span>
              <span class="progress-right">
                <span id="rightBar" class="progress-bar"></span>
              </span>
              <div class="progress-value">{{timeLeft}}</div>
            </div>
            <span>Seconds</span>
          </div>
          <div class="clear"></div>
        </div>
        </transition>
      </div>

    <div class="answerBox" v-show="showAnswer">
      <div class="quiz-answer" v-if="correctAnswer">
        <div class="quiz-answer-inner">
          <p><i class="fa fa-check" aria-hidden="true"></i>That's Correct</p>
          <button @click="goToNextQuiz" class="next">Next <i class="fa fa-angle-right"></i></button>
          <div class="clear"></div>
        </div>
      </div>
      <div class="quiz-answer quiz-answer-false" v-else>
        <div class="quiz-answer-inner">
          <p><i class="fa fa-remove"></i>That's Incorrect</p>
          <button @click="goToNextQuiz" class="next">Next <i class="fa fa-angle-right"></i></button>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable max-len */
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'Questionnaire',

    props: {
      quiz: {
        type: Object,
      },
      currentProgress: {
        type: Number,
      },
      showTimer: {
        type: Boolean,
      },
      showAnswer: false,
      correctAnswer: {
        type: Boolean,
      },
      isStatus: false,
      totalIndexes: null,
      currentQuesIndex: null,
      isDisabled: {
        type: Boolean,
      },
    },

    created() {
      this.startTimer();
    },

    destroyed() {
      this.stopTimer();
    },

    computed: {
      ...mapGetters(['getCurrentQuizIndex']),
      progressBarRef() {
        return document.getElementById('dynamic');
      },
      timerLeftBar() {
        return document.getElementById('leftBar');
      },
      timerRightBar() {
        return document.getElementById('rightBar');
      },
    },

    mounted() {
      this.progressBarRef.style.width = `${this.currentProgress}%`;
    },

    data() {
      return {
        selectedOptionIndex: -1,
        timeLeft: 0,
        interval: null,
        status: null,
      };
    },

    methods: {
      ...mapMutations(['updateScore']),
      goToNextQuiz() {
        this.selectedOptionIndex = -1;
        this.stopTimer();
        this.timerLeftBar.classList.remove('progress-bar');
        this.timerRightBar.classList.remove('progress-bar');
        const a = this.timerLeftBar.offsetWidth;
        const b = this.timerRightBar.offsetWidth;
        this.progressBarRef.style.width = `${this.currentProgress}%`;
        this.$emit('nextQuiz');
        this.startTimer();
        if (!a || !b) {
          this.timerLeftBar.classList.add('progress-bar');
          this.timerRightBar.classList.add('progress-bar');
        }
      },

      checkAnswer(index) {
        this.progressBarRef.style.width = `${this.currentProgress}%`;
        this.stopTimer();
        this.selectedOptionIndex = index;
        this.$emit('optionClicked', index);
        let autoTimer = 3000;
        if (screen.width <= 575) {
          autoTimer = 1500;
        }
        const timer = setTimeout(() => {
          if (this.showAnswer === false) { this.startTimer(); }
        }, autoTimer);
        const element = document.getElementsByClassName('next');
        element[0].addEventListener('click', () => {
          clearTimeout(timer);
        });
        element[1].addEventListener('click', () => {
          clearTimeout(timer);
        });
      },

      startTimer() {
        this.timeLeft = 20;
        this.interval = setInterval(this.countDown, 1000);
      },

      stopTimer() {
        clearInterval(this.interval);
      },

      countDown() {
        if (this.timeLeft > 0) {
          this.timeLeft -= 1;
        } else {
          this.goToNextQuiz();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .Questionnaire {
    background: #fafdff none repeat scroll 0 0;
    padding: 25px 0 0px;
    height: 100vh;
    .container {
      max-width: 1100px;
    }

    .disabled {
      pointer-events: none;
      opacity: 0.8;
    }

    form {
      padding: 5px 0 0;
      position: relative;
    }

    .skip {
      position: absolute;
      right: 0;
      top: 0;
    }

    .skip > a {
      color: #c6d1dd;
      font-size: 20px;
      font-family: "Roboto", sans-serif;
      font-weight: 300;
    }

    .skip > a:hover {
      color: #54a3ff;
    }

    .progress {
      height: 2px;
      position: relative;
      overflow: visible;
      width: 80%;
      padding: 12px 0 100x 0;
      left: 2%;
      right: 90px;
      display: inline-block;
    }
    .progress-bar-data {
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      color: #54a3ff;
      top: 9px;
      position: absolute;
      left: 82%;
    }
    .progress .progress-bar {
      height: 1em !important;
      position: absolute;
      top: -5px;
      border-radius: 16px;
      background: linear-gradient(264deg, #0180d0, #a0e3fd);
    }
    ul#status {
      margin: 55px -220px 55px;
      top: 105px;
      width: 100vw;
      text-align: center;
    }

    ul#status > li {
      background: #fafdff none repeat scroll 0 0;
      border: 3px solid #d9e2ee;
      border-radius: 100%;
      display: inline-block;
      height: 20px;
      position: relative;
      width: 20px;
      margin: 0 0 0 55px;
      z-index: 2;
    }

    ul#status > li:first-child {
      margin-left: 0;
    }

    ul#status > li::after {
      background: #d9e2ee none repeat scroll 0 0;
      content: "";
      height: 3px;
      position: absolute;
      right: 17px;
      top: 5px;
      width: 55px;
      z-index: 1;
    }

    ul#status > li:first-child::after {
      display: none;
    }

    ul#status > li.active {
      border-color: #54a3ff;
    }

    ul#status > li.active::after {
      background: #54a3ff none repeat scroll 0 0;
    }

    ul#status > li.passed::after {
      background: #54a3ff none repeat scroll 0 0;
    }

    ul#status > li.passed {
      background: #54a3ff url("../../../assets/img/right.png") no-repeat center center;
      border: 3px solid rgba(84, 163, 255, 0.1);
      box-shadow: 0 0 15px 0 rgba(84, 163, 255, 0.7);
    }

    .question-box {
      margin: 30px 0 50px;
    }

    .question-box h4.question {
      color: #28282e;
      font-family: "Roboto", sans-serif;
      font-size: 40px;
      font-weight: 400;
      line-height: 55px;
      margin: 0 0 55px;
      text-align: center;
    }

    ul.answers {
      margin: 0;
      text-align: center;
    }

    ul.answers > li {
      background: #ffffff none repeat scroll 0 0;
      border: 1px solid #e8f0f9;
      border-radius: 6px;
      box-shadow: 0 2px 8px 0 rgba(217, 226, 238, 0.38);
      color: #28282e;
      cursor: pointer;
      display: inline-block;
      font-size: 28px;
      font-weight: 200;
      letter-spacing: 1px;
      line-height: 120px;
      margin: 0 1% 25px;
      min-height: 120px;
      padding: 15px 25px;
      text-align: left;
      vertical-align: middle;
      width: 46%;
      position: relative;
    }

    ul.answers > li.selected {
      border-color: #54a3ff;
      box-shadow: 0 0 0 2px #54a3ff;
    }

    ul.answers > li:hover {
      border-color: #bdd9f8;
      box-shadow: 0 0 0 2px #bdd9f8;
    }

    .answers input {
      bottom: 0;
      display: inline-block;
      height: 42px;
      margin: auto;
      opacity: 0;
      position: absolute;
      top: 0;
      vertical-align: middle;
      width: 42px;
      z-index: 1;
    }

    .answers input + label {
      display: inline-block;
      vertical-align: middle;
      margin: 0;
      line-height: 35px;
      position: relative;
      padding: 0 0 0 80px;
    }

    .answers input + label::before {
      background: #ffffff none repeat scroll 0 0;
      border: 6px solid #d9e2ee;
      border-radius: 100%;
      bottom: 0;
      content: "";
      display: block;
      height: 42px;
      left: 0px;
      margin: auto;
      position: absolute;
      top: 0;
      width: 42px;
    }

    .answers .right input + label::before {
      background: rgba(0, 0, 0, 0) url("../../../assets/img/path-2.png") no-repeat scroll center center / 20px auto;
      border-color: #3ec7a9;
    }
    ul.answers > li.right {
      border-color: #3ec7a9 !important;
      box-shadow: 0 0 0 2px #3ec7a9 !important;
    }
    ul.answers > li.wrong {
      border-color: #ff6d7f !important;
      box-shadow: 0 0 0 2px #ff6d7f !important;
    }

    .answerBox{
      position: fixed;
      bottom: 0;
      width: 100%;
    }
    .quiz-answer {
      background: #3ec7a9 none repeat scroll 0 0;
      padding: 60px 0;
      margin-bottom: 0;
    }

    .quiz-answer-inner {
      margin: 0 auto;
      max-width: 1000px;
      padding: 0 255px 27px 252px;
    }

    .quiz-answer p {
      color: #ffffff;
      float: left;
      font-family: "Roboto", sans-serif;
      font-size: 24px;
      font-weight: normal;
      margin: 0;
      letter-spacing: 1px;
    }

    .quiz-answer p i {
      border: 6px solid #ffffff;
      border-radius: 100%;
      font-size: 35px;
      font-weight: normal;
      height: 60px;
      line-height: 47px;
      margin: 0 20px 0 0;
      text-align: center;
      vertical-align: middle;
      width: 60px;
    }

    .quiz-answer button {
      background: #ffffff none repeat scroll 0 0;
      border: 1px solid #ffffff;
      border-radius: 24px;
      box-shadow: 0 6px 8px 0 rgba(94, 105, 119, 0.2);
      float: right;
      height: 48px;
      line-height: 48px;
      padding: 0 40px;
      color: #3ec7a9;
      font-size: 21px;
      margin: 6px 0 0;
      cursor: pointer;
      font-family: "Roboto", sans-serif;
      &:hover{
        .fa-angle-right{
          font-size: 20px;
          opacity: 1;
          left: 15px;
        }
      }
      .fa-angle-right{
        font-size: 0px;
        opacity: 0;
        position: relative;
        left: 0px;
        -webkit-transition: all 0.5s linear;
        -moz-transition: all 0.5s linear;
        -o-transition: all 0.5s linear;
        transition: all 0.5s linear;
      }
    }
    .mobile{
      display: none;
    }
    .quiz-answer button:hover,
    .quiz-answer button:focus {
      background: none;
      color: #ffffff;
      box-shadow: none;
    }
    /*** quiz-false ***/

    ul.answers > li.selected.selected-false {
      border-color: #ff6d7f;
      box-shadow: 0 0 0 2px #ff6d7f;
    }
    .answers .wrong input + label::before {
      border-color: #ff6d7f;
      background: rgba(0, 0, 0, 0) url("../../../assets/img/group-7.png") no-repeat scroll center center / 20px auto;
    }
    .quiz-answer.quiz-answer-false {
      background: #ff6d7f none repeat scroll 0 0;
    }
    .quiz-answer.quiz-answer-false button {
      color: #ff6d7f;
    }
    .quiz-answer.quiz-answer-false button:hover,
    .quiz-answer.quiz-answer-false button:focus {
      color: #fff;
    }
    ul.answers.answers-img > li {
      height: 300px;
      line-height: 270px;
      padding: 15px;
      vertical-align: middle;
      width: 260px;
      text-align: center;
    }
    ul.answers.answers-img > li img {
      max-height: 100%;
      max-width: 100%;
    }
    /*** quiz-timer ***/

    .quiz-answer.quiz-timer {
      background: #ffffff none repeat scroll 0 0;
      margin-top: -3%;
      padding: 10px 0;
    }
    .quiz-answer.quiz-timer button {
      background: rgba(0, 0, 0, 0) linear-gradient(263deg, #68ffed, #0575e6) repeat scroll 0 0;
      color: #ffffff;
    }
    .quiz-answer.quiz-timer button:hover,
    .quiz-answer.quiz-timer button:focus {
      background: rgba(0, 0, 0, 0) linear-gradient(263deg, #0575e6, #68ffed) repeat scroll 0 0;
    }
    .timer-box {
      margin: 0 auto;
      text-align: center;
      width: 90px;
    }
    .timer-box > span {
      color: #28282e;
      display: block;
      font-size: 12px;
      margin: 8px 0 0;
    }
    .progress-blue {
      width: 100%;
      height: 90px;
      line-height: 90px;
      background: none;
      margin: 0;
      box-shadow: none;
      position: relative;
    }
    .progress-blue > span {
      width: 50%;
      height: 100%;
      overflow: hidden;
      position: absolute;
      top: 0;
      z-index: 1;
    }
    .progress-blue .progress-left {
      left: 0;
    }
    .progress-blue .progress-bar {
      width: 100%;
      height: 100%;
      background: none;
      border: 6px solid #0575e6;
      position: absolute;
      top: 0;
    }
    .progress-blue .progress-left .progress-bar {
      left: 100%;
      border-top-right-radius: 80px;
      border-bottom-right-radius: 80px;
      border-left: 0;
      -webkit-transform-origin: center left;
      transform-origin: center left;
    }
    .progress-blue .progress-right {
      right: 0;
    }
    .progress-blue .progress-right .progress-bar {
      left: -100%;
      border-top-left-radius: 80px;
      border-bottom-left-radius: 80px;
      border-right: 0;
      -webkit-transform-origin: center right;
      transform-origin: center right;
      animation: loading-1 10s linear forwards;
    }
    .progress-blue .progress-value {
      border-radius: 100%;
      color: #28282e;
      font-size: 48px;
      font-weight: normal;
      height: 100%;
      text-align: center;
      width: 100%;
    }
    .progress-blue .progress-left .progress-bar {
      animation: loading-2 10s linear forwards 10s;
    }
    @keyframes loading-1 {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
      }
    }
    @keyframes loading-2 {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
      }
    }
    .que-img {
      background: #ffffff none repeat scroll 0 0;
      border: 1px solid #e8f0f9;
      border-radius: 8px;
      box-shadow: 0 2px 8px 0 rgba(217, 226, 238, 0.38);
      float: left;
      height: 250px;
      margin: 0 20px 0 0;
      padding: 0;
      text-align: center;
      width: 400px;
      line-height: 220px;
      padding: 15px;
    }

    .que-img > img {
      max-height: 100%;
      max-width: 100%;
    }

    .question-box h4.question.question-img {
      font-size: 35px;
      line-height: 45px;
      text-align: left;
    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity .4s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    .fade-enter-to{
      opacity: 1;
    }
    /*** Responsive ***/
    @media (min-width: 1199px) and (max-width: 2000px) {
      ul#status {
        margin-left: -25%;
      }
    }

    @media (min-width: 992px) and (max-width: 1199px) {
      .container {
        max-width: 960px;
      }
      ul#status {
        margin-left: -20%;
      }
      ul#status > li {
        margin-left: 40px;
      }
      ul#status > li::after {
        width: 44px;
      }
    }
    @media (max-width: 991px) {
      .container {
        max-width: 720px;
      }
      ul#status {
        margin-left: -20%;
      }
      ul#status > li {
        margin-left: 20px;
      }
      ul#status > li::after {
        width: 24px;
      }
      .question-box h4.question {
        font-size: 32px;
        line-height: 40px;
      }
      ul.answers > li {
        font-size: 20px;
        padding: 15px;
      }
      .answers input + label {
        line-height: 28px;
        padding-left: 55px;
      }
      ul.answers.answers-img > li {
        width: 30%;
      }
      .que-img {
        float: none;
        margin: 0 auto 20px;
      }
      .question-box h4.question.question-img {
        text-align: center;
      }
      .progress{
        width: 71%;
      }
      .progress-bar-data{
        left: 76%;
      }
      .quiz-answer-inner {
        padding: 0px 147px 27px 173px;
      }
    }
    @media (max-width: 767px) {
      .container {
        max-width: 540px;
      }
      ul#status {
        margin-left: -10%;
      }
      .quiz-menu {
        float: none;
        margin: 0 0 20px;
        text-align: center;
      }
      ul#status {
        margin-left: 100px;
        margin-bottom: 10px;
        max-width: 100%;
      }
      ul#status > li {
        margin-left: 30px;
      }
      ul#status > li::after {
        width: 34px;
      }
      .skip {
        position: relative;
        right: auto;
        top: auto;
        margin: 0 auto 20px;
        text-align: center;
      }
      ul.answers > li {
        display: block;
        margin: 0 0 20px;
        width: 100%;
      }
      ul.answers.answers-img > li {
        width: 100%;
      }
      .progress{
        left: 2%;
        width: 100%;
        right: 90px;
      }
      .progress-bar-data{
          top: -10px;
          position: absolute;
          left: 46%;
      }
      .quiz-answer-inner {
        padding: 0px 97px 27px 45px;
      }
    }
    @media (max-width: 575px) {
      .container {
        max-width: 100%;
      }
      .next{
        display: none;
      }
      .progress{
        left: 0;
        width: 71%;
        right: 0;
      }

      .mobile {
        display: inline-block;
        float: right;
        padding: 0 27px;
        margin: 0px 0 0;
        cursor: pointer;
        a{
          font-size: 18px;
          color: #a0a8b1;
          font-family: "Roboto", sans-serif;
          text-decoration: none;
          &:hover{
            color: #a0a8b1;
          }
        }

        .fa-angle-right{
          font-size: 20px;
          opacity: 1;
          position: relative;
          left: 10px;
        }
      }

      ul#status {
        margin-left: 7%;
      }

      ul#status > li {
        margin-left: 6px;
      }
      ul#status > li::after {
        width: 10px;
      }
      .question-box h4.question {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 30px;
      }
      ul.answers > li {
        font-size: 18px;
        min-height: 0px;
        line-height: 0px;
      }
      .quiz-answer {
        padding: 4px 0;
      }
      .quiz-answer p i {
        height: 40px;
        width: 40px;
        line-height: 35px;
        border-width: 3px;
        font-size: 25px;
        margin-right: 10px;
      }
      .quiz-answer p {
        font-size: 20px;
        padding-left: 5px;
        //margin: 9px;
        float: none;
      }
      .quiz-answer-inner {
        text-align: center;
        padding: 4px;
      }
      .quiz-answer button {
        //float: none;
        //margin: 0px;
        display: none;
      }
      .que-img {
        width: 100%;
      }
    }
    @media (max-width: 400px) {
      .progress{
        width: 60%;
      }
      .mobile{
        padding: 0 20px;
        font-size: 17px;
        .fa{
          font-size: 17px;
        }
      }
    }
  }

  .opaque {
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    z-index: 2;
    background: #757575;
    opacity: 0.5;
    .status {
      z-index: 2;
      background: #757575;
      opacity: 0.5;
    }
    .que-img {
      background: #757575;
    }
    ul.answers > li {
      background: #757575;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/Quiz/components/Questionnaire.vue